import {useEffect} from 'react';
import Head from 'next/head';
import {Container} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {px} from '@eksab/theme';

import {AuthenticationRequiredAlert, Background, Register} from '@eksab/features/auth/components';
import {useRouter} from 'next/router';
import {GetStaticProps} from 'next';
import {dehydrate, QueryClient} from '@tanstack/react-query';
import {setApiLocale} from '@eksab/api';
import {useRegionSettings} from '@eksab/hooks/useRegionSettings';

export default function RegisterPage() {
  const t = useTranslate();
  const router = useRouter();

  useEffect(() => {
    mixpanel?.track('Page View', {page: 'Register'});
  }, []);

  useEffect(() => {
    if (router.query.referrer && typeof router.query.referrer === 'string') {
      sessionStorage.setItem('referrer', router.query.referrer);
    }
  }, [router.query.referrer]);

  return (
    <>
      <Head>
        <meta name="description" content="Predict game score and win prizes | Eksab" />
        <title>{`${t('app.actions.register')} | ${t('app.name')}`}</title>
      </Head>

      <AuthenticationRequiredAlert />

      <Background>
        <Container
          display="flex"
          flexDir="column"
          justifyContent="center"
          m="auto"
          shadow={['none', null, 'md']}
          px={[...px.slice(0, 3), null]}
          py="10"
          w={['100%', null, '480px']}
          textAlign="center"
          rounded="md"
          bgColor="white"
        >
          <Register />
        </Container>
      </Background>
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
  const queryClient = new QueryClient();

  setApiLocale(locale);

  await queryClient.prefetchQuery([useRegionSettings.queryKey, locale], useRegionSettings.queryFn);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60 * 60 * 3,
  };
};
